const text = (value) => String(value ?? "").trim();

const safePart = (value) => text(value).normalize("NFC")
  .replace(/[<>:"\/\\|?*\u0000-\u001F]/g, " ").replace(/\s+/g, " ")
  .replace(/[. ]+$/g, "").trim();

export const invoicePdfFilename = (invoice = {}) => {
  const snapshot = invoice?.companySnapshot || {};
  const company = invoice?.company || {};
  const legalName = snapshot.corporateName || company.corporateName ||
    snapshot.tradeName || company.tradeName || "EMPRESA";
  const companyName = safePart(legalName).toLocaleUpperCase("pt-BR")
    .slice(0, 140).trim().replace(/[. ]+$/g, "") || "EMPRESA";
  const reference = text(invoice?.reference || invoice?.options?.reference);
  const matched = /^(\d{1,2})\/(\d{4})$/.exec(reference);
  const monthReference = matched
    ? matched[1].padStart(2, "0") + "-" + matched[2]
    : safePart(reference.replace(/\//g, "-")) || "SEM-REFERENCIA";
  const number = /^\d+$/.test(text(invoice?.id)) ? text(invoice.id) : "SEM-NUMERO";
  return companyName + " - NF " + number + " - " + monthReference + ".pdf";
};

export const invoiceFilenameFromHeader = (header) => {
  const value = text(header);
  const utf8 = /(?:^|;)\s*filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i.exec(value);
  if (utf8) {
    try {
      const decoded = decodeURIComponent(utf8[1].trim().replace(/^"|"$/g, ""));
      if (decoded.toLowerCase().endsWith(".pdf")) return safePart(decoded);
    } catch (_) { /* fallback para filename ASCII */ }
  }
  const ascii = /(?:^|;)\s*filename\s*=\s*"([^"]+)"/i.exec(value);
  return ascii?.[1]?.toLowerCase().endsWith(".pdf") ? safePart(ascii[1]) : "";
};
